// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"signAgreementQR_wrapper__2JSb_","header":"signAgreementQR_header__2HJjy","label":"signAgreementQR_label__3OD4w","body":"signAgreementQR_body__166ij"};